import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import validatorStyle from "./validatorStyle";
import { ValidatorType } from "../../types/ValidatorType";
import { OutlinedInputProps, TextFieldProps } from "@mui/material";

type ValidatorTextFieldProps = {
  name: string;
  value: string | number;
  registerValidators?: Function;
  validators?: Array<ValidatorType>;
  isHighlighted?: boolean;
  initialDependentValidationFields?: Array<string>;
  label: string;
  InputProps?: OutlinedInputProps;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
} & TextFieldProps;

const ValidatorTextField = ({
  name,
  value,
  registerValidators = () => {},
  validators = [],
  isHighlighted = false,
  initialDependentValidationFields = [],
  label,
  InputProps,
  inputProps = {},
  multiline,
  ...rest
}: ValidatorTextFieldProps) => {
  useEffect(() => {
    registerValidators && validators && registerValidators(name, validators, initialDependentValidationFields);
    return () => {
      registerValidators && registerValidators(name, []);
    };
  }, []);

  if (!multiline && !inputProps.maxLength) {
    inputProps.maxLength = 250;
  }

  return (
    <TextField
      {...rest}
      name={name}
      value={value}
      label={label}
      slotProps={{
        input: InputProps,
        htmlInput: inputProps,
        ...rest.slotProps,
      }}
      multiline={multiline}
      sx={isHighlighted && (value === null || value === "") ? validatorStyle.mandatory : null}
    />
  );
};

export default ValidatorTextField;
